import React, { useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import { actions as customerActions } from '../redux/customerActions';
import { Button, Loader } from '../../../common/components';
import InternalContainer from '../../layout/containers/Internal';
import CustomerForm from '../components/CustomerForm/CustomerForm';

const INITIAL_ADDITIONAL_MARKETING = {
  car_insurance_purchased: undefined,
  home_insurance_purchased: undefined,
  home_insurance_due: undefined,
  car_insurance_due: undefined,
};
const getCustomerFormValues = (resource) => {
  if (!resource) {
    return null;
  }
  const additionalMarketing =
    resource.data.attributes.metadata?.marketing_additional_info;
  const formAdditionalMarketing =
    !additionalMarketing || Array.isArray(additionalMarketing)
      ? INITIAL_ADDITIONAL_MARKETING
      : additionalMarketing;
  return {
    data: {
      id: resource.data.id,
      attributes: {
        ...resource.data.attributes,
        metadata: {
          ...resource.data.attributes.metadata,
          marketing_additional_info: formAdditionalMarketing,
        },
      },
    },
  };
};
const CustomerEditContainer = ({ getCustomer, updateCustomer, customer, params }) => {
  const customerId = params.id;
  useEffect(
    () => {
      getCustomer(customerId);
    },
    [customerId, getCustomer],
  );

  const handleUpdateCustomer = (values) => {
    return updateCustomer(values);
  };

  const resource = customer?.resources?.[customerId];
  const customerFormValues = useMemo(() => getCustomerFormValues(resource), [resource]);
  if (!customerFormValues) {
    return (
      <InternalContainer
        title="Customer"
        buttons={
          <Button
            bsStyle="default"
            label="Back"
            isBackButton={true}
            leftIcon="caret-left"
          />
        }
      >
        <Loader />
      </InternalContainer>
    );
  }

  return (
    <InternalContainer
      title="Customer"
      buttons={
        <Button
          bsStyle="default"
          label="Back"
          isBackButton={true}
          leftIcon="caret-left"
        />
      }
    >
      <CustomerForm resource={customerFormValues} onSaveCustomer={handleUpdateCustomer} />
    </InternalContainer>
  );
};

export default connect(
  (state) => ({
    customer: state.customer,
  }),
  {
    getCustomer: customerActions.getCustomer,
    updateCustomer: customerActions.updateCustomer,
  },
)(CustomerEditContainer);
